import React from 'react';
import PropTypes from 'prop-types';
import AnswerNumber from './answers/AnswerNumber';
import AnswerText from './answers/AnswerText';
import AnswerYesNo from './answers/AnswerYesNo';
import AnswerCheckbox from './answers/AnswerCheckbox';

export default class Answer extends React.Component {
  render() {
    const {
      answerType,
      answerValues,
      answerHandler,
      inputValue,
    } = this.props;


    if (answerType === 'Number') {
      return (
        <AnswerNumber
          answerHandler={answerHandler}
          inputValue={inputValue}
        />
      );
    }
    if (answerType === 'Text') {
      return (
        <AnswerText
          answerHandler={answerHandler}
          inputValue={inputValue}
        />
      );
    }
    if (answerType === 'Yes / No') {
      return (
        <AnswerYesNo
          answerValues={answerValues}
          answerHandler={answerHandler}
          inputValue={inputValue}
        />
      );
    }

    return (
      <AnswerCheckbox
        answerHandler={answerHandler}
        answerValues={answerValues}
        inputValue={inputValue}
      />
    );
  }
}

Answer.propTypes = {
  answerType: PropTypes.string.isRequired,
  answerValues: PropTypes.arrayOf(PropTypes.string),
  answerHandler: PropTypes.func.isRequired,
  inputValue: PropTypes.arrayOf(PropTypes.string).isRequired,
};

Answer.defaultProps = {
  answerValues: [],
};
